export const KDS_COLUMNS = [
  { key: 'new', label: 'Novo', value: 'novo' },
  { key: 'accepted', label: 'Aceito', value: 'aceito' },
  { key: 'preparing', label: 'Preparando', value: 'preparando' },
  { key: 'ready', label: 'Pronto', value: 'pronto' },
]

const STATUS_ALIASES = {
  new: ['new', 'novo', 'pending', 'pendente', 'aguardando'],
  accepted: ['accepted', 'aceito', 'aprovado'],
  preparing: ['preparing', 'preparando', 'in_preparation', 'em_preparo'],
  ready: ['ready', 'pronto', 'pronto_para_retirada'],
}

export function canonicalStatus(status) {
  const normalized = String(status || '').toLowerCase()
  return Object.keys(STATUS_ALIASES).find(key => STATUS_ALIASES[key].includes(normalized)) || normalized
}

export function getKdsStatus(item) {
  return item?.kdsStatus || item?.status || ''
}

export function statusValueFor(item, targetKey) {
  const current = String(getKdsStatus(item))
  const isEnglish = ['new', 'pending', 'accepted', 'preparing', 'in_preparation', 'ready'].includes(current.toLowerCase())
  const values = isEnglish
    ? { new: 'new', accepted: 'accepted', preparing: 'preparing', ready: 'ready' }
    : Object.fromEntries(KDS_COLUMNS.map(column => [column.key, column.value]))
  const value = values[targetKey]
  return current === current.toUpperCase() ? value.toUpperCase() : value
}

export function unwrapItems(payload) {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.items)) return payload.items
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export function getItemId(item) {
  return item?.id || item?.kdsItemId || item?.productOrderId
}

export function getOrderId(item) {
  return item?.orderId || item?.idOrder || item?.order?.id || getItemId(item)
}

export function getOrderNumber(item) {
  return item?.orderNumber || item?.numOrder || item?.order?.numOrder || item?.order?.number || String(getOrderId(item) || '').slice(0, 8)
}

export function getSector(item) {
  const sector = item?.sector || item?.product?.sector
  return {
    id: item?.sectorId || item?.idSector || sector?.id || null,
    name: item?.sectorName || sector?.name || 'Sem setor',
  }
}

export function groupByOrder(items) {
  return Object.values(items.reduce((groups, item) => {
    const key = getOrderId(item)
    if (!groups[key]) groups[key] = { key, number: getOrderNumber(item), items: [] }
    groups[key].items.push(item)
    return groups
  }, {}))
}

export function originLabel(item) {
  const value = String(item?.origin || item?.typeOrder || item?.order?.typeOrder || '').toLowerCase()
  if (value.includes('ifood')) return 'iFood'
  if (value.includes('mesa') || value.includes('table') || value.includes('comanda')) return item?.tableName ? `Mesa · ${item.tableName}` : 'Mesa'
  if (value.includes('delivery') || value.includes('entrega')) return 'Delivery'
  if (value.includes('retirada') || value.includes('pickup')) return 'Retirada'
  if (value.includes('balcao') || value.includes('balcão') || value.includes('frente-de-caixa')) return 'Balcão'
  return value || 'Loja'
}

export function itemCreatedAt(item) {
  return item?.createdAt || item?.created_at || item?.orderCreatedAt || item?.order?.createdAt
}

export function formatElapsed(createdAt, now = Date.now()) {
  const started = new Date(createdAt).getTime()
  if (!Number.isFinite(started)) return '--:--'
  const totalMinutes = Math.max(0, Math.floor((now - started) / 60000))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return hours ? `${hours}h ${String(minutes).padStart(2, '0')}min` : `${minutes} min`
}
